// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-settingssectiontoggle] > span:first-child {\n  padding-inline: 0 !important;\n  flex-direction: row-reverse;\n}\n\n[data-settingssectiontoggle] > span:first-child > span {\n  padding-inline: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
